import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Application, BrFooter, GovBrAlertMessagesModule, GovBrFooterModule, GovBrMainLayoutModule, Menu, User } from "@serpro/ngx-dsgovbr";
import { MyLoadingComponent } from "../my-loading/my-loading.component";

@Component({
	selector: 'main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: ['./main-layout.component.css'],
	standalone: true,
	imports: [
		CommonModule,
		GovBrMainLayoutModule,
		GovBrFooterModule,
		RouterModule,
		MyLoadingComponent,
		GovBrAlertMessagesModule
	]
})
export class MainLayoutComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
		this.usuario = new User('Usuário', 'usuario@example.com');
	}

	ctx = null;

	usuario: User | undefined;

	menu: Menu = {
		overlay: false,
		showFilter: true,
		closeOnSelect: true,
		itens: [
			{
				label: 'Cálculo de Tributos',
				action: '/calcular-tributos'
				// icon: 'fas fa-tasks',
			},
			{
				label: 'Base de Cálculo',
				// icon: 'fas fa-tasks',
				itens: [
					{
						label: 'CBS e IBS',
						action: '/base-de-calculo-cibs',
						// icon: 'fas fa-table'
					},
					{
						label: 'IS Mercadorias',
						action: '/base-de-calculo-is-mercadorias',
						// icon: 'fas fa-table'
					}
				]
			},
			{
				label: 'Fundamentações Legais',
				action: '/consultar-fundamentacoes'
				// icon: 'fas fa-tasks',
			},
			{
				label: 'Calculadora Offline',
				// icon: 'fas fa-tasks',
				itens: [
					{
						label: 'Download',
						action: '/calculadora-offline-download',
						// icon: 'fas fa-table'
					},
					{
						label: 'Documentação',
						action: '/calculadora-offline-documentacao',
						// icon: 'fas fa-table'
					}
				]
			},
		]
	}

	modules = [
		// {
		// 	name: 'Showcase',
		// 	displayName: 'Showcase',
		// 	icon: 'fas fa-question-circle',
		// 	route: '/'
		// },
	];

	app: Application = {
		//menu: this.menu,
		fixedWidth: true,
		
		version: '',
		name: '',
		modules: this.modules,
		headerType: 'standard',
		headerDensity: 'large',
		headerSticky: false,
		showHighContrastButton: true,
		headerSign: 'Calculadora de Tributos - RTC',
	};

	footer: BrFooter = {
		show: true,
		theme: '2',
		legalInfo: 'O Padrão Digital de Governo utiliza as licenças CC0 1.0 Universal e MIT.',
		logoUrl: './assets/receitaAzul.svg',
		socialMedia: {
			label: 'Redes Sociais',
			items: [
				{
					url: 'https://www.facebook.com/receitafederaloficial/',
					cssClass: 'fab fa-facebook'
				},
				{
					url: 'https://twitter.com/ReceitaFederal',
					cssClass: 'fab fa-twitter'
				},
				{
					url: 'https://www.youtube.com/tvreceitafederal',
					cssClass: 'fab fa-youtube',
				}
			]
		},
		partners: [
			{
				url: 'https://www.gov.br/acessoainformacao',
				imgUrl: './assets/informacao.svg'
			},
			{
				url: 'https://www.gov.br/',
				imgUrl: './assets/govbr.svg'
			}
		]
	}
}


